import type { BrowseCategorySlug } from '@members/browse-categories';
import { browseCategorySlugToCaesarMapper } from '@members/browse-categories';
import { useGetCategoriesData } from '@members/browse-categories/hooks/useGetCategoriesData';

export const useShouldShowQuotaOnLibraryPage = (categorySlug: BrowseCategorySlug) => {
  const allBrowseCategories = useGetCategoriesData();
  const mappedActiveCategory = browseCategorySlugToCaesarMapper(categorySlug);

  const activeCat =
    allBrowseCategories?.filter(cat => cat.slug === mappedActiveCategory)[0] ?? null;

  return activeCat?.hasLimitedRides ?? false;
};
